var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fee-form',{attrs:{"edit":_vm.edit,"stepper":true},on:{"added":_vm.afterSave,"updated":_vm.afterSave,"cancel":_vm.backToList}})}
var staticRenderFns = []

export { render, staticRenderFns }